import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SPECIAL_USER_EMAIL } from '../utils/constants';

const SpecialUserRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Check if user has the special email (case-insensitive)
  const isSpecialUser = user?.email?.toLowerCase() === SPECIAL_USER_EMAIL;
  
  // If authenticated but not the special user, redirect to dashboard
  if (!isSpecialUser) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // If special user, allow access
  return children;
};

export default SpecialUserRoute;
